import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyclops-copyright',
  templateUrl: './cyclops-copyright.component.html',
  styleUrls: ['./cyclops-copyright.component.scss']
})
export class cyclopsCopyrightComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
